import React from 'react'

const SingleCoupen = () => {
  return (
    <>
        <div className='light-blue-box'>
            <div className='off'>
                <h3>$5</h3>
                <p>OFF</p>
                <div className='white-circle-abs'></div>
                <div className='blue-circle-abs'></div>
            </div>
            <div className='off-content'>
                <h3>Sitewide Sale</h3>
                <p>Dec 13, 2023 - Dec 05, 2023</p>
            </div>
        </div>
    </>
  )
}

export default SingleCoupen